import { Component, OnInit } from "@angular/core";
import { Redirection } from "@tytapp/common";
import { LiveStreamsService } from "@tytapp/common-ui";
import { UserService } from "@tytapp/user";
import { ActivatedRoute } from "@angular/router";
import { ApiLiveStream, AppApi } from "@tytapp/api";

@Component({
    selector: 'tyt-live-jump',
    templateUrl: './live-jump.component.html',
    styleUrls: ['./live-jump.component.scss']
})
export class LiveJumpComponent implements OnInit {

    constructor(
        private redirection: Redirection,
        private liveStreamsService: LiveStreamsService,
        private usersService: UserService,
        private route: ActivatedRoute,
        private appApi: AppApi
    ) { }

    qc: boolean = false;
    stream: ApiLiveStream = null;

    ngOnInit() {
        this.route.data.subscribe(async data => {
            if (!data)
                data = {};

            // Check if there is a Cloudflare redirect
            // Original Context: At some point Cenk wanted tyt.com/live to go to a third party live stream for
            // easy call outs on air.
            // TODO: This causes problems with the live stream jump functionality-- the redirect from TYT.com
            // itself gets misconstrued as a Cloudflare redirect, and the result is that all TYT.com session always
            // jump to the public stream, because the request to check the redirect is done without credentials.
            // TLDR: this needs to be seriously rethought before being re-enabled.
            // if (!isServerSide() && !data.mode) {
            //     let response: any = await this.appApi.lookupRedirect('/live').toPromise();
            //     if (response && response.url) {
            //         window.location.assign(response.url);
            //         return;
            //     }
            // }

            this.qc = false;

            await this.usersService.ready;
            let user = this.usersService.user;
            let streams = await this.liveStreamsService.active();
            let entitled = user != null && user.entitled;

            streams = streams.sort((a, b) => {
                if (b.active !== a.active)
                    return Number(b.active) - Number(a.active);
                else
                    return (new Date(b.created_at).getTime() - (new Date(a.created_at).getTime()));
            });

            if (!streams || streams.length == 0) {
                this.redirection.go(`/live/schedule`, true);
                return;
            }

            let premiumStream = streams.find(x => x.premium);
            let publicStream = streams.find(x => !x.premium);
            let stream = null;

            if (entitled) {
                stream = premiumStream || publicStream;
            } else {
                stream = publicStream || premiumStream;
            }

            if (data.mode === 'qc-members') {
                this.qc = true;
                stream = premiumStream;
            } else if (data.mode === 'qc-public') {
                this.qc = true;
                stream = publicStream;
            }

            this.stream = stream;

            if (stream) {
                this.redirection.go(`/live/streams/${stream.id}`, true);
                return;
            }

            if (this.qc)
                return;

            this.redirection.go(`/live/schedule`, true);
        });
    }
}
